interface IconProps {
  color?: string;
  style?: React.CSSProperties;
}

const Icon = ({ style = {} }: IconProps) => {
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width="89" height="89" viewBox="0 0 89 89" fill="none">
      <circle cx="44.4769" cy="44.4769" r="44.4769" fill="white" fill-opacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.9033 41.8532H47.7556C47.3621 41.8532 47.0998 41.591 47.0998 41.1975V30.0498C47.0998 29.2629 46.5752 28.7383 45.7884 28.7383H43.1654C42.3785 28.7383 41.8539 29.2629 41.8539 30.0498V41.1975C41.8539 41.591 41.5916 41.8532 41.1981 41.8532H30.0504C29.2635 41.8532 28.7389 42.3778 28.7389 43.1647V45.7877C28.7389 46.5746 29.2635 47.0992 30.0504 47.0992H41.1981C41.5916 47.0992 41.8539 47.3615 41.8539 47.755V58.9027C41.8539 59.6896 42.3785 60.2142 43.1654 60.2142H45.7884C46.5752 60.2142 47.0998 59.6896 47.0998 58.9027V47.755C47.0998 47.3615 47.3621 47.0992 47.7556 47.0992H58.9033C59.6902 47.0992 60.2148 46.5746 60.2148 45.7877V43.1647C60.2148 42.3778 59.6902 41.8532 58.9033 41.8532"
        fill="#B8B8BB"
      />
    </svg>
  );
};

export default Icon;
